import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cross from "../../assets/images/icon/cross.svg";
import { faImages, faLock, faUpload } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { at, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { uploadUserDocuments } from "helpers/backend_helper";
import { useEffect, useState } from "react";
import { bytesToMB } from "helpers/common";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { checkPermissionStatus, generateMaskedPII } from "helpers/utils";

const DrivingLicense = props => {
  const { t } = useTranslation();
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [userDetails, setUserDetails] = useState({
    licenseNumber: "",
    fullName: "",
    bloodGroup: "",
    parentName: "",
    dob: "",
    address: "",
    issueDate: "",
    expireDate: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [viewType, setViewType] = useState("view");
  const candidateDetails = props?.data?.fields
    ? JSON.parse(props?.data?.fields)
    : "";

  const validateDrivingLicense = val => {
    let inputvalues = val;
    let regex = new RegExp(
      /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/
    );
    return regex.test(inputvalues);
  };

  const imageTypeAllowed = [
    "application/doc",
    "application/docx",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleFileUpload = async e => {
    setErrors({ ...errors, attachmentFile: "" });
    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;
      if (e?.target?.files?.length > 1) {
        toast.error(
          t(`Driving License.Cannot Select More than one Attachment`)
        );
        return false;
      }
      for (let i = 0; i < e?.target?.files?.length; i++) {
        if (!imageTypeAllowed?.includes(e?.target?.files[i]?.type)) {
          isError = true;
        }
        let megabytes = bytesToMB(e?.target?.files[i].size);
        if (megabytes > maxSize) {
          toast.error(
            t(`Driving License.Please select attachment of size below 25 MB`)
          );
          return false;
        }
        setAttachmentFile(e?.target?.files[i]);
      }
      if (isError) {
        toast.error(
          t(`Driving License.Please upload attachment with the following types`)
        );
        return;
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    let error = {};
    let isError = false;
    if (isEmpty(userDetails?.licenseNumber)) {
      error = {
        ...error,
        licenseNumber: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (!attachmentFile) {
      error = {
        ...error,
        attachmentFile: t(`Driving License.Attachment is Required`),
      };
      isError = true;
    }
    if (isEmpty(userDetails?.fullName)) {
      error = {
        ...error,
        fullName: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (isEmpty(userDetails?.parentName)) {
      error = {
        ...error,
        parentName: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (!userDetails?.dob) {
      error = { ...error, dob: t(`Driving License.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.address)) {
      error = {
        ...error,
        address: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (!userDetails?.issueDate) {
      error = {
        ...error,
        issueDate: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (!userDetails?.expireDate) {
      error = {
        ...error,
        expireDate: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }
    if (!userDetails?.bloodGroup) {
      error = {
        ...error,
        bloodGroup: t(`Driving License.This Field is Required`),
      };
      isError = true;
    }

    if (!validateDrivingLicense(userDetails?.licenseNumber?.trim())) {
      error = {
        ...error,
        licenseNumber: t(`Driving License.Please Enter Valid Details`),
      };
      isError = true;
    }

    if (isError) {
      toast.error(t(`Driving License.Please Enter Valid Details`));
      setLoading(false);
      setErrors(error);
      return false;
    }

    let userID = props?.user_id;

    let payload = {
      ...userDetails,
      type: "drivingDetails",
      new_status: "Driving Details",
      attachmentFile: attachmentFile,
      appl_id: props?.appl_id,
    };

    await uploadUserDocuments(payload, userID)
      .then(res => {
        toast.success(
          t(`Driving License.Driving License Details Updated Successfully`)
        );
        setLoading(false);
        props?.onSubmit();
        setViewType("view");
      })
      .then(err => {
        if (err?.response?.message) {
          toast.error(JSON.stringify(err?.response?.message));
        }
        setLoading(false);
      });
  };

  const handleAttachmentOpen = () => {
    if (attachmentFile) {
      if (typeof attachmentFile === "string") {
        window.open(attachmentFile);
      } else {
        window.open(URL.createObjectURL(attachmentFile));
      }
    }
  };

  const handleReset = () => {
    if (props?.data?.fields) {
      let myData = JSON.parse(props?.data?.fields);
      let attachmentNew = props?.data?.files;
      setUserDetails({
        licenseNumber: myData?.licenseNumber,
        fullName: myData?.fullName,
        bloodGroup: myData?.bloodGroup,
        parentName: myData?.parentName,
        dob: myData?.dob,
        address: myData?.address,
        issueDate: myData?.issueDate,
        expireDate: myData?.expireDate,
      });
      setAttachmentFile(attachmentNew);
    }
  };

  useEffect(() => {
    if (props?.data?.fields) {
      let myData = JSON.parse(props?.data?.fields);
      let attachmentNew = props?.data?.files;
      setUserDetails({
        licenseNumber: myData?.licenseNumber,
        fullName: myData?.fullName,
        bloodGroup: myData?.bloodGroup,
        parentName: myData?.parentName,
        dob: myData?.dob,
        address: myData?.address,
        issueDate: myData?.issueDate,
        expireDate: myData?.expireDate,
      });
      setAttachmentFile(attachmentNew);
    }
  }, [props?.data]);

  return (
    <>
      {/* <div className="modal-header d-flex justify-content-between align-items-center">
        <h4 className="m-0">
          {viewType === "edit" ? "Upload" : "View"} Driving License Details
        </h4>

        <div className="filter-content cross" onClick={() => props?.close()}>
          <img src={cross} alt="" />
        </div>
      </div> */}
      <div className="d-flex justify-content-between align-items-center modal-subheading mb-2">
        <h4 className="d-flex gap-2 align-items-center">
          {t(`Driving License.Driving License`)}
        </h4>
        <div>
          {viewType === "view" ? (
            <Link
              className="text-success blue-icon blue-color4"
              to={`#`}
              onClick={() => setViewType("edit")}
              title={t(`Driving License.Edit Details`)}
            >
              <img src={edit_icon} alt="delete_icon" />
            </Link>
          ) : (
            <button
              onClick={() => {
                setViewType("view");
                handleReset();
              }}
              className="btn btn-secondary"
            >
              {t(`Driving License.Cancel`)}
            </button>
          )}
        </div>
      </div>
      {viewType === "edit" && (
        <div className="filters-cards-cross">
          <form
            onSubmit={handleSubmit}
            id="schedulef2f"
            style={{ display: "block" }}
          >
            <div className="form-group">
              <div className="row">
                <div className="voter-upload">
                  <label className="btn btn-primary upload-button">
                    <FontAwesomeIcon icon={faUpload} />
                    <span className="mx-2">
                      {t(`Driving License.Upload Driving License`)}
                    </span>
                    <input
                      type="file"
                      multiple
                      accept={imageTypeAllowed.join(",")}
                      onChange={e => {
                        handleFileUpload(e);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                  {attachmentFile && (
                    <FontAwesomeIcon
                      className="mx-4"
                      icon={faImages}
                      style={{ cursor: "pointer" }}
                      width={"25px"}
                      height={"25px"}
                      onClick={() => handleAttachmentOpen()}
                    />
                  )}

                  <p className="pb-2">
                    {t(`Driving License.Supported file types are`)}
                  </p>
                  {errors?.attachmentFile && (
                    <p className="text-danger mt-2 mx-1">
                      {errors?.attachmentFile}
                    </p>
                  )}
                </div>
                <div className="row form-upload-card">
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.License Number`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="licenseNumber"
                        type="text"
                        className="form-control"
                        placeholder={t(`Driving License.DL Number`)}
                        value={userDetails?.licenseNumber}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            licenseNumber: e.target.value,
                          });
                          setErrors({ ...errors, licenseNumber: "" });
                        }}
                        title={`${t(`Driving License.License Number`)}`}
                      />
                    </div>
                    {errors?.licenseNumber && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.licenseNumber}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Name`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="name"
                        type="text"
                        className="form-control"
                        placeholder={t(`Driving License.Enter Full Name`)}
                        value={userDetails?.fullName}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            fullName: e.target.value,
                          });
                          setErrors({ ...errors, fullName: "" });
                        }}
                        title={`${t(`Driving License.Name`)}`}
                      />
                    </div>
                    {errors?.fullName && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.fullName}
                      </p>
                    )}
                  </div>

                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Date of Birth`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.dob ? new Date(userDetails?.dob) : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            dob: date,
                          });
                          setErrors({ ...errors, dob: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        scrollableYearDropdown
                        maxDate={new Date()?.setFullYear(
                          new Date()?.getFullYear() - 18
                        )}
                        placeholderText={t(`Driving License.Select Date`)}
                        title={`${t(`Driving License.Date of Birth`)}`}
                      />
                    </div>
                    {errors?.dob && (
                      <p className="text-danger mt-2 mx-1">{errors?.dob}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Blood Group`)}
                    </span>
                    <div className="mt-2">
                      <select
                        for="bloodGroup"
                        className="form-control"
                        value={userDetails?.bloodGroup}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            bloodGroup: e.target.value,
                          });
                          setErrors({ ...errors, bloodGroup: "" });
                        }}
                        onMouseEnter={e => {
                          e.target.setAttribute(
                            "title",
                            e.target.options[e.target.selectedIndex].text
                          );
                        }}
                      >
                        <option value="Select">
                          {t(`Driving License.Select`)}
                        </option>
                        <option value="O-">O-</option>
                        <option value="O+">O+</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                        <option value="A-">A-</option>
                        <option value="A+">A+</option>
                        <option value="B-">B-</option>
                        <option value="B+">B+</option>
                      </select>
                    </div>
                    {errors?.bloodGroup && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.bloodGroup}
                      </p>
                    )}
                  </div>

                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Parent's/Spouse's Name`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="spouseName"
                        type="text"
                        className="form-control"
                        placeholder={t(
                          `Driving License.Enter Parent's/Spouse's Name`
                        )}
                        value={userDetails?.parentName}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            parentName: e.target.value,
                          });
                          setErrors({ ...errors, parentName: "" });
                        }}
                        title={`${t(`Driving License.Parent's/Spouse's Name`)}`}
                      />
                    </div>
                    {errors?.parentName && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.parentName}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {" "}
                      {t(`Driving License.Issued Date`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.issueDate
                            ? new Date(userDetails?.issueDate)
                            : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            issueDate: date,
                          });
                          setErrors({ ...errors, issueDate: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        maxDate={new Date()}
                        placeholderText={t(`Driving License.Select Date`)}
                        title={`${t(`Driving License.Issued Date`)}`}
                      />
                    </div>
                    {errors?.issueDate && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.issueDate}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Expiry Date`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.expireDate
                            ? new Date(userDetails?.expireDate)
                            : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            expireDate: date,
                          });
                          setErrors({ ...errors, expireDate: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        minDate={new Date()}
                        placeholderText={t(`Driving License.Select Date`)}
                        title={`${t(`Driving License.Expiry Date`)}`}
                      />
                    </div>
                    {errors?.expireDate && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.expireDate}
                      </p>
                    )}
                  </div>

                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Driving License.Address`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="address"
                        type="text"
                        className="form-control"
                        placeholder={t(`Driving License.Enter Address`)}
                        value={userDetails?.address}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            address: e.target.value,
                          });
                          setErrors({ ...errors, address: "" });
                        }}
                        title={`${t(`Driving License.Address`)}`}
                      />
                    </div>
                    {errors?.address && (
                      <p className="text-danger mt-2 mx-1">{errors?.address}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="serach-btn d-flex justify-content-start">
                <button className="btn btn-primary search">
                  {t(`Driving License.Save`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {viewType === "view" && candidateDetails && (
        <>
          <div className="personal-card">
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.License Number`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {generateMaskedPII(candidateDetails?.licenseNumber, 2)}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Name`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.fullName}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Date of Birth`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.dob)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Blood Group`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.bloodGroup}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Parent's/Spouse's Name`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.parentName}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Issued Date`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.issueDate)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Expiry Date`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.expireDate)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Address`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.address}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Driving License.Document`)}
                  {attachmentFile &&
                  !checkPermissionStatus(
                    "personal-id-info",
                    "view_unmasked"
                  ) ? (
                    <>
                      {" "}
                      <FontAwesomeIcon
                        icon={faLock}
                        title="You are not authorized to view this document"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  {attachmentFile && (
                    <FontAwesomeIcon
                      className="mx-4"
                      icon={faImages}
                      style={{ cursor: "pointer" }}
                      width={"25px"}
                      height={"25px"}
                      onClick={() =>
                        !checkPermissionStatus(
                          "personal-id-info",
                          "view_unmasked"
                        )
                          ? null
                          : handleAttachmentOpen()
                      }
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="line-braker"></div>
        </>
      )}
      {viewType === "view" && !candidateDetails && (
        <p className="pdf-details">
          {t(`Driving License.No Details Available`)}
        </p>
      )}
    </>
  );
};

export default DrivingLicense;
